// extracted by css-extract-rspack-plugin
export default {"root":"je9gK8","heading":"BO0yLh","statusRow":"No88rw","subscribeButton":"HwE8BK"};